import { render, staticRenderFns } from "./QuotaShotList.vue?vue&type=template&id=b0f1b008&scoped=true&"
import script from "./QuotaShotList.vue?vue&type=script&lang=js&"
export * from "./QuotaShotList.vue?vue&type=script&lang=js&"
import style0 from "./QuotaShotList.vue?vue&type=style&index=0&id=b0f1b008&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0f1b008",
  null
  
)

export default component.exports